<app-consult-note-history-item-title>
  {{ title }}
</app-consult-note-history-item-title>

<app-consult-note-history-item-body>
  @if (rolledUpTransitionedCaptureStatusCounts.length > 0) {
    <p>Consult note submitted and captures were transitioned:</p>
    <ul>
      @for (entry of rolledUpTransitionedCaptureStatusCounts; track entry) {
        <li>
          {{ displayTransitionedCounts(entry) }}
        </li>
      }
    </ul>
  } @else {
    <p>Consult note submitted and no captures were transitioned.</p>
  }

  @if (rolledUpFailedTransitionedCaptureStatusCounts.length > 0) {
    <p>Not transitioned:</p>
    <ul>
      @for (entry of rolledUpFailedTransitionedCaptureStatusCounts; track entry) {
        <li>
          {{ displayTransitionedCounts(entry) }}
        </li>
      }
    </ul>
  }
</app-consult-note-history-item-body>
